import React from 'react';
import { projects } from './ResumeData';

export function Projects() {
  return (
    <main className="Projects">
      <h2>Technical Projects</h2>
      {projects.map(project => (
        <article className="card text-start mb-3" key={project.name}>
          <div className="card-body">
            <h3 className="card-title h5">{project.name}</h3>
            <p><strong>{project.role}</strong></p>
            <p>{project.description}</p>
            <p><strong>Technologies:</strong> {project.technologies}</p>
            <a href={project.link} target="_blank" rel="noreferrer">GitHub Repository</a>
            {project.additionalLink && <> | <a href={project.additionalLink} target="_blank" rel="noreferrer">Testing Repository</a></>}
          </div>
        </article>
      ))}
    </main>
  );
}
